// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2x7CW","gfeWrapper":"CalendarEvent_gfeWrapper__3-zGO"};